module.exports = __webpack_public_path__ + "assets/places2_blue.95bca0ca.svg";